export const alertStatuses = ['ACTIVE', 'RESOLVED'] as const;
export type AlertStatus = (typeof alertStatuses)[number];
